import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import List from "../../components/List";
import { Button, Input } from "../../components/Form";
import { MdAdd } from "react-icons/md";
import Modal from "../../components/Modals/Modal";
import { FaSave } from "react-icons/fa";
import { useAppSelector } from '../../store';

import { getAllLabProducts, createLabProduct } from "../../api/labProduct";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function Products() {
	const userData = useAppSelector((state) => state.userData);

	const [modal, setModal] = useState(false);


	const [products, setProducts] = useState([]);
	const [loading, setLoading] = useState(false);
	const [pageLoader, setPageLoader] = useState(true);
	const [name, setName] = useState("");
	const [price, setPrice] = useState("");

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await getAllLabProducts({ labId: userData?.user?.defaultLabId });
			console.log(res);
			setProducts(res);
			setPageLoader(false);
		};

		if (userData?.user?.defaultLabId) {
			fetchData();
		} else {
			setPageLoader(false);
		}
	}, [userData, modal]);


	const handleSubmit = async () => {
		if (!name.trim()) {
			toast.error("Name is required");
			return;
		}

		const data = {
			labId: userData?.user?.defaultLabId,
			name: name,
			price: price || 0,
		};

		setLoading(true);
		const response = await createLabProduct(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setName("");
			setPrice("");
		}
		setLoading(false);
	};

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<>
						{
							products.length === 0 ?
								<div className="text-center text-lg my-4">No Products Found</div>
								:
								<Container className={"flex flex-1 flex-col divide-y rounded-xl "}>
									<List list={products} path={"products"} />
								</Container>
						}
						<div className="flex justify-center items-center my-2">
							<Button
								className={"w-52 max-w-fit px-5"}
								label={"Add New Product"}
								Icon={() => <MdAdd size={22} />}
								onClick={() => setModal(true)}
							/>
						</div>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Add Products"}>
							<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} name={"name"} color value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Price (BAM)"} placeholder={"Price"} color type={"number"} min={0} name={"rates"} value={price} onChange={(e) => setPrice(e.target.value)} />
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSubmit} loading={loading} />
						</Modal>
					</>
			}
		</Layout>
	);
}

export default Products;
